import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";

import {CONFIG} from "../../../app/config";
import {TAction} from '../../../app/enum';

import {LogadoService} from '../../../providers/logado-service';
import {HotspotService} from "../../../providers/hotspot-service";
import {ShowhourPage} from '../showhour/showhour';


@Component({
    selector: 'page-showopen',
    templateUrl: 'showopen.html',
    providers: [HotspotService]
})

export class ShowopenPage {

    config: any;
    logado: any;

    requestQtde: number = 0;
    requestCode: string = '';
    barcodeCode: string = '';

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showopen', '/showopen');

        this.showingLoad();

    }

    showingInit() {
        
        //this.requestQtde = 0;
        //this.showingLoad();

        this.showhour(null);

    }

    showingLoad() {

        this.requestQtde++;


        let params = '';

        let loading = this.util.loadingDots();
        loading.present();

        this.logadoService.started(TAction.acOpen, null, params)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                if (data.ShowingTipo == 1) {
                    this.showhour(data.Hotspots);
                    return;
                }

                this.requestCode = data.RequestCode;

                let timeout = 5 * 1000;
                if (this.requestQtde < 10) setTimeout(() => this.showingLoad(), timeout)
                if (this.requestQtde >= 10) this.requestCode = '';

            }, erro => {

                this.util.toastSimply(erro.Result);

            });

    }

    showhour(hotspots) {

        //if (!hotspots || !hotspots.length) return;
        this.navCtrl.setRoot(ShowhourPage, {hotspotList: hotspots});

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showopen/showopen.ts